<div fxLayout="column" fxFlex="0 0 100%" class="user-notes-listing">
    <mat-accordion displayMode="flat">
        <mat-expansion-panel expanded="true" #expansionPanel>
            <mat-expansion-panel-header> </mat-expansion-panel-header>
            <app-table-filter [cacheScope]="AppScope.RESOURCES" [inGlobalFilter]="true" color="accent" #filter>
                <app-table-search
                    [inGlobalFilter]="true"
                    placeHolder="Search for note or resource"
                    toggleBtnLabel="Search"
                    i18n-toggleBtnLabel
                    i18n-placeHolder
                    class="align-space"
                    searchFilterRef
                ></app-table-search>
                <app-user-chip-search-filter
                    [inGlobalFilter]="true"
                    [filterSpecs]="filterSpecs"
                    searchLabel="Author"
                    chosingLabel="Choose author"
                    searchPlaceholder="Filter by author name.."
                    i18n-chosingLabel
                    i18n-searchPlaceholder
                    i18n-searchLabel
                    authorsFilterRef
                ></app-user-chip-search-filter>
                <app-select-filter
                    [inGlobalFilter]="true"
                    class="filter-space"
                    label="All Time"
                    i18n-label
                    [property]="GlobalFilterProperty.TIME_SPENT"
                    [options]="predefinedTimeSpentOptions"
                    fixedTimeSpentFilterRef
                >
                </app-select-filter>
            </app-table-filter>
        </mat-expansion-panel>
    </mat-accordion>
    <mat-progress-bar
        class="progress-table-loader mt-1"
        *ngIf="(dataSource.status | async) === 'loading'"
        mode="indeterminate"
    ></mat-progress-bar>
    <mat-table
        #table
        [dataSource]="dataSource"
        multiTemplateDataRows
        matSortDirection="desc"
        matSortActive="created_at"
        matSort
    >
        <ng-container matColumnDef="created_at">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n="@@time">Time</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let note">
                <span class="mobile-label" i18n="@@time">Time:</span>
                {{ note.created_at | kdDateFormat: 'YYYY-MM-DD HH:mm' }}
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="notes">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Note</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let note">
                <span class="mobile-label" i18n>Note:</span>
                <div fxLayout="row" fxLayoutGap="3px" fxLayoutAlign="start center">
                    <span class="notes-holder">{{ note.body }}</span>
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="author">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n="@@author">Author</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let note">
                <span class="mobile-label" i18n="@@author">Author:</span>
                <div
                    [ngClass]="{
                        'dark-blue-bg': note.author.role_value === 'user',
                        'green-bg': note.author.role_value !== 'user'
                    }"
                    class="reciever-user chip-wrap"
                    fxLayoutGap="5px"
                    fxLayout="row"
                >
                    <mat-icon>{{ note.author.role_value | userRoleIcon }}</mat-icon>
                    <span>{{ note.creator.name }}</span>
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="context">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n="@@resource">Resource</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let note">
                <span class="mobile-label" i18n="@@resource">Resource:</span>
                <span (click)="$event.stopPropagation(); onResClick(note.noteResource.title)">
                    {{ note.noteResource?.title }}
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="expand">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let note">
                <button
                    (click)="$event.stopPropagation(); expandedRow = expandedRow === note ? null : note"
                    matTooltip="View"
                    mat-icon-button
                    i18n-matTooltip="@@view"
                >
                    <mat-icon>{{ expandedRow === note ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
            <mat-cell *matCellDef="let note" [attr.colspan]="columns.length">
                <div class="example-element-detail" [@detailExpand]="note == expandedRow ? 'expanded' : 'collapsed'">
                    <ng-container *ngIf="expandedRow == note">
                        <app-notes-resource-listing-details [note]="note"></app-notes-resource-listing-details
                    ></ng-container>
                </div>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row
            *matRowDef="let note; columns: columns"
            [class.example-expanded-row]="expandedRow === note"
            (click)="expandedRow = expandedRow === note ? null : note"
            class="example-element-row"
        ></mat-row>
        <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></mat-row>
    </mat-table>
    <mat-paginator [pageSize]="25" [pageSizeOptions]="[25, 50, 100]"> </mat-paginator>
</div>

<ng-template #loading>
    <div fxLayout="row" fxLayoutAlign="center center" class="spinner-container mt-2">
        <mat-spinner fxFlex="0 0 auto"></mat-spinner>
    </div>
</ng-template>
